

const SaveUnsaveButton = ({ imageId, deletedIds, onClickHandler }) => {

  return <button className={`absolute bottom-2 right-2 border rounded-xl ${deletedIds.has(imageId) ? 'bg-red-500' : 'bg-slate-500'} text-white px-2 text-xs border-black`} onClick={onClickHandler} id={imageId}>{deletedIds.has(imageId) ? 'Save' : 'Unsave'}</button>
}
export default SaveUnsaveButton
